import download from "./download";
import phone from "./phone";
import section from "./section";
import email from "./email";
import checkout from "./checkout";
import dialog from "./dialog";

export default [download, phone, section, email, checkout, dialog];
